import { Results, log } from "@tumbodash/browserPackages";
import type { Party } from "../../types.js";

interface PlayerStanding {
	partyPoints: number;
	player: string;
	color: string;
	playerId: string;
	isReady: boolean;
	place?: number;
}

function placePlayers(party: Party): PlayerStanding[] {
	log.fx("module:party:placePlayers");
	const playerKeys = Object.keys(party.players);
	const playerStandings: PlayerStanding[] = [];

	for (let i = 0; i < playerKeys.length; i++) {
		const player = party.players[playerKeys[i]];
		player.partyPoints = 0;
		for (let x = 0; x < (party.rounds as unknown as unknown[]).length; x++) {
			const round = (party.rounds as unknown as Array<{ standings: Record<string, number> }>)[x];
			player.partyPoints += round.standings[player.id];
		}
	}

	for (let i = 0; i < playerKeys.length; i++) {
		const player = party.players[playerKeys[i]];
		playerStandings.push({
			partyPoints: player.partyPoints,
			player: player.name,
			color: player.color,
			playerId: player.id,
			isReady: player.isReady,
		});
	}

	playerStandings.sort((a, b) => b.partyPoints - a.partyPoints);

	const tableArr: PlayerStanding[] = [];
	let offset = 0;
	for (let i = 0; i < playerStandings.length; i++) {
		if (i > 0 && playerStandings[i].partyPoints === playerStandings[i - 1].partyPoints)
			offset++;
		playerStandings[i].place = i + 1 - offset;
		tableArr.push(playerStandings[i]);
	}

	return tableArr;
}

export default placePlayers;
